import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export enum HotelTypes {
    Hotel = 1,
    ServicedApartments = 2,
    HotelApartments = 3
}

@Injectable({
    providedIn: 'root'
})
export class HotelAssetClassService {
    private _hotelTypes$ = new BehaviorSubject([
        {id: HotelTypes.Hotel, name: 'Hotel'},
        {id: HotelTypes.ServicedApartments, name: 'Serviced Apartments'},
        {id: HotelTypes.HotelApartments, name: 'Hotel Apartments'}
    ])

    private _hotelRatings$ = new BehaviorSubject([
        {id: 1, name: '1 star'},
        {id: 2, name: '2 star'},
        {id: 3, name: '3 star'},
        {id: 4, name: '4 star'},
        {id: 5, name: '5 star'},
    ]) 

    private _hotelApartmentRatings$ = new BehaviorSubject([
        {id: 1, name: 'Standard rating'},
        {id: 2, name: 'Superior rating'},
        {id: 3, name: 'Deluxe rating'}
    ])

    fetchHotelTypes() {
        return this._hotelTypes$.asObservable()
    }

    fetchHotelRatings() {
        return this._hotelRatings$.asObservable()
    }

    fetchHotelApartmentRatings() {
        return this._hotelApartmentRatings$.asObservable()
    }
}